export default __webpack_public_path__ + "static/media/css.cf3cce0c.png";